module.exports = __webpack_public_path__ + "img/gaia48-2.0b7dddbf.png";